import { Moment } from 'moment';

import { ItemOrderHistoryBase } from 'app/buffer-graph/models/item-order-history/item-order-history-base';

export class ItemOrderHistory extends ItemOrderHistoryBase<ItemOrderHistory> {
    constructor(
        orderId: number,
        date: Moment,
        planArriveDate: Moment,
        order: number,
        status: number,
        statusDescr: string,
        fulfillment: number,
        fulfillmentDescr: string,
        arrivalDate: Moment,
        arrivedQuantity: number,
        supplierCode: string,
        supplierName: string,
        buffer: number,
        safetyStock: number,
        balance: number,
        inTransit: number,
        need: number,
        hasData: string,
        hasMoq: string,
        hasMoa: string,
        isCwh: boolean,
        crossDock: any) {
        super(orderId,
            date,
            planArriveDate,
            order,
            status,
            statusDescr,
            fulfillment,
            fulfillmentDescr,
            arrivalDate,
            arrivedQuantity,
            supplierCode,
            supplierName,
            buffer,
            safetyStock,
            balance,
            inTransit,
            need,
            hasData,
            hasMoq,
            hasMoa,
            isCwh,
            crossDock);
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/item-order-history/item-order-history.ts